import {gsap} from '../../vendors/gsap';
import isEnterOrSpacePressed from '../../helpers/isEnterOrSpacePressed';

// Get all elements
const headers = document.querySelectorAll('.accordion-header');
const toggles = document.querySelectorAll('.accordion-toggle');
const wrappers = document.querySelectorAll('.accordion-content-wrapper');
const contents = document.querySelectorAll('.accordion-content');

let animating = false;

/**
 * Expand single accordion
 *
 * @param {Element} header - accordion header
 * @param {Element} toggle - toggle icon
 * @param {Element} wrapper - accordion content wrapper
 * @param {Element} content - accordion content
 */
const expandItem = (header, toggle, wrapper, content) => {
    // Update aria label and title
    header.setAttribute('title', header.dataset.labelClose);
    header.setAttribute('aria-expanded', true);

    // Animate
    gsap.to(toggle, {ease: 'power1.out', rotateX: '180'});
    gsap.to(wrapper, {
        ease: 'power1.out',
        autoAlpha: 1,
        height: 'auto'
    });
    gsap.fromTo(
        content,
        {yPercent: '-100', ease: 'power1.out'},
        {
            ease: 'power1.out',
            yPercent: '0',
            /**
             * On completion of open animation
             */
            onComplete() {
                header.classList.add('active');
                animating = false;
            }
        }
    );
};

/**
 * Collapse single accordion
 *
 * @param {Element} header - accordion header
 * @param {Element} toggle - toggle icon
 * @param {Element} wrapper - accordion content wrapper
 * @param {Element} content - accordion content
 */
const collapseItem = (header, toggle, wrapper, content) => {
    // Update aria label and title
    header.setAttribute('title', header.dataset.labelOpen);
    header.setAttribute('aria-expanded', false);

    // Animate
    gsap.to(toggle, {ease: 'power1.out', rotateX: '0'});
    gsap.to(wrapper, {ease: 'power1.out', height: '0'});
    gsap.to(content, {
        ease: 'power1.out',
        yPercent: '-100',
        /**
         * On completion of close animation
         */
        onComplete() {
            gsap.set(wrapper, {autoAlpha: 0, height: 0});
            header.classList.remove('active');
            animating = false;
        }
    });
};

/**
 * Collapse all accordions
 */
export const collapseAccordions = () => {
    if (animating) return;
    animating = true;

    headers.forEach((header, i) => {
        if (header.classList.contains('active')) {
            collapseItem(header, toggles[i], wrappers[i], contents[i]);
        }
    });
};

/**
 * Handle the accordion click event
 * Expand only one item per time
 *
 * @param {number} idx - index of clicked accordion
 */
const handleAccordionClick = idx => {
    animating = true;

    headers.forEach((header, i) => {
        if (!header.classList.contains('active')) {
            if (idx === i) {
                expandItem(header, toggles[i], wrappers[i], contents[i]);
            } else {
                collapseItem(header, toggles[i], wrappers[i], contents[i]);
            }
        } else {
            collapseItem(header, toggles[i], wrappers[i], contents[i]);
        }
    });
};

/**
 * Add event listeners
 */
export const onAccordionClick = () => {
    headers.forEach((header, i) => {
        header.addEventListener('click', () => {
            handleAccordionClick(i);
        });
        header.addEventListener('keydown', e => {
            if (isEnterOrSpacePressed(e)) {
                e.preventDefault();
                handleAccordionClick(i);
            }
        });
    });
};
